import styled, { css } from 'styled-components';
import MediaQueryBreakpoints from '@/v2/constants/MediaQueryBreakpoints';
import { maxWidth, pxToVw } from '@/modules/styled/cssUnits';
import { PublicStyledGlobals } from 'styles/publicGlobals.styled';
import { padding, compactPadding } from '@rockalingua/ui/constants/Layout';

export const StyledPublicPage = styled(PublicStyledGlobals)`
  --page-lateral-padding: ${pxToVw(80)};

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .public-page-topbar {
    padding: ${padding}px ${padding}px 20px;
    width: 100%;
    max-width: ${maxWidth}px;

    @media (${MediaQueryBreakpoints.isUltraWide}) {
      padding: ${compactPadding}px ${compactPadding}px 10px;
    }

    @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
      padding: ${compactPadding}px ${compactPadding}px 10px;
    }
  }

  .public-page-layout {
    max-width: ${(props) => (props?.noMaxWidth ? '100%' : `${maxWidth}px`)};
    margin: 0;

    width: 100%;
    padding: 0 ${padding}px ${padding}px;
    min-height: 100vh;

    @media (${MediaQueryBreakpoints.isUltraWide}) {
      padding: 0 ${compactPadding}px ${compactPadding}px;
    }

    @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
      padding: 0 ${compactPadding}px ${compactPadding}px;
    }

    ${(props) =>
      props?.noPadding &&
      css`
        padding: 0px !important;
      `};

    .public-page-content {
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    --page-lateral-padding: ${compactPadding}px;
    --page-top-padding: 60px;
    --page-bottom-padding: ${pxToVw(160)};
  }
`;
